/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Payload to update an existing user.
 * @export
 * @interface UpdateUserRequest
 */
export interface UpdateUserRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateUserRequest
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserRequest
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserRequest
     */
    phone?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserRequest
     */
    role?: UpdateUserRequestRoleEnum;
    /**
     * 
     * @type {number}
     * @memberof UpdateUserRequest
     */
    companyId?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserRequest
     */
    avatarUrl?: string | null;
}


/**
 * @export
 */
export const UpdateUserRequestRoleEnum = {
    Owner: 'owner',
    Admin: 'admin',
    Member: 'member',
    Viewer: 'viewer'
} as const;
export type UpdateUserRequestRoleEnum = typeof UpdateUserRequestRoleEnum[keyof typeof UpdateUserRequestRoleEnum];


/**
 * Check if a given object implements the UpdateUserRequest interface.
 */
export function instanceOfUpdateUserRequest(value: object): value is UpdateUserRequest {
    return true;
}

export function UpdateUserRequestFromJSON(json: any): UpdateUserRequest {
    return UpdateUserRequestFromJSONTyped(json, false);
}

export function UpdateUserRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateUserRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'] == null ? undefined : json['email'],
        'name': json['name'] == null ? undefined : json['name'],
        'phone': json['phone'] == null ? undefined : json['phone'],
        'role': json['role'] == null ? undefined : json['role'],
        'companyId': json['companyId'] == null ? undefined : json['companyId'],
        'avatarUrl': json['avatarUrl'] == null ? undefined : json['avatarUrl'],
    };
}

export function UpdateUserRequestToJSON(json: any): UpdateUserRequest {
    return UpdateUserRequestToJSONTyped(json, false);
}

export function UpdateUserRequestToJSONTyped(value?: UpdateUserRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'email': value['email'],
        'name': value['name'],
        'phone': value['phone'],
        'role': value['role'],
        'companyId': value['companyId'],
        'avatarUrl': value['avatarUrl'],
    };
}

